import FormProduto from "components/FormProduto";

const CriarPruduto = () => (
  <div className="card">
    <FormProduto />
  </div>
);

export default CriarPruduto;
